import React from 'react'

import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/styles'


const useStyle = makeStyles({
    card: {
        background: '#fff',
        maxWidth: '50vw',
        maxHeight: '30vh',
        borderRadius: 10
    }
})

export const Error = error => {
    const classes = useStyle();

    return (
        <Grid
            container
            direction="column"
            alignItems="center"
            style={{ marginTop: '10%' }}
        >
            <Grid item xs={12}>
                <Card variant="outlined" className={classes.card}>
                    <CardContent>
                        <Typography variant="h6" color="textSecondary">
                            Something went wrong. <a href='/'>Click here</a> to go back to home.
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}